/**
 * Zod validation schemas for setup forms.
 */

import { z } from 'zod';

/**
 * Schema for setup form data.
 * Validates the initial setup form with password confirmation.
 */
export const setupSchema = z
  .object({
    name: z.string().min(1, 'Name is required').max(100, 'Name must be at most 100 characters'),
    email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
    password: z.string().min(1, 'Password is required').min(8, 'Password must be at least 8 characters'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export type SetupFormData = z.infer<typeof setupSchema>;
